import { Suspense } from 'react';
import { v4 as uuid } from 'uuid';
import { Image } from 'rsuite';
import { useTheme } from '../../contexts/ThemeContext';

import {
  ROCKET,
  CLOUD_1,
  CLOUD_2,
  TANIWHA,
  BOAT,
  BALLOON,
  KID_1,
  KID_2,
  KID_3,
  KID_4,
  BOY,
  GIRL,
  DOODLE_BOAT,
  DOODLE_PLANE,
  DOODLE_SPACE,
  CLOUD_1_WHITE,
  CLOUD_2_WHITE,
  HEART_WHITE,
  STAR_WHITE,
  TANIWHA_WHITE,
  FLOWER_WHITE,
  FLOWER_WHITE_2,
  SPACESHIP_WHITE,
  SPACE_WHITE,
  BUBBLES_WHITE,
  NOTES_WHITE,
  LIGHTBULBS_WHITE,
  AIRPLANE_WHITE,
  AIRPLANE_WHITE_2,
  BOAT_WHITE,
  LIGHBULB_WHITE
  
} from '../../utils/constants/images';

const images = [
  CLOUD_2,
  GIRL,
  TANIWHA,
  CLOUD_1,
  BOY,
  KID_3,
  BALLOON,
  KID_1,
  KID_2,
  KID_4,
  BOAT,
  ROCKET,
  
];

const doodleImages = [
  DOODLE_BOAT,
  DOODLE_PLANE,
  DOODLE_SPACE,
];

const doodleImagesDark = [
  CLOUD_1_WHITE,
  CLOUD_2_WHITE,
  HEART_WHITE,
  STAR_WHITE,
  TANIWHA_WHITE,
  FLOWER_WHITE,
  FLOWER_WHITE_2,
  SPACESHIP_WHITE,
  SPACE_WHITE,
  BUBBLES_WHITE,
  NOTES_WHITE,
  LIGHTBULBS_WHITE,
  AIRPLANE_WHITE,
  AIRPLANE_WHITE_2,
  BOAT_WHITE,
  LIGHBULB_WHITE
];


function hashStringToNumber(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0;
  }
  return hash;
}

function getRandomImage({ seed = uuid(), doodle = false, darkmode, ...props }) {
  const { isDarkMode } = useTheme();
  const _images = doodle ? (( isDarkMode || darkmode) ? doodleImagesDark : doodleImages) : images;
  const hash = hashStringToNumber(seed);
  const index = Math.abs(hash) % _images.length;
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Image src={_images[index]} {...props} />
    </Suspense>
  );
}

export default getRandomImage;
